import script from "./UserHomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserHomeView.vue?vue&type=script&setup=true&lang=js"

import "./UserHomeView.vue?vue&type=style&index=0&id=cd6c5d90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd6c5d90"]])

export default __exports__